/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddCalculationitemForSaleDto } from '../models/work-add-calculationitem-for-sale-dto';
import { WorkCalculation } from '../models/work-calculation';
import { WorkCalculationitem } from '../models/work-calculationitem';
import { WorkCreateCalculationitemDto } from '../models/work-create-calculationitem-dto';
import { WorkCreateDiscountCalculationitemDto } from '../models/work-create-discount-calculationitem-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkMoveCalculationItemsToProjectsDto } from '../models/work-move-calculation-items-to-projects-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkRevertPendingOptionalInclusionsDto } from '../models/work-revert-pending-optional-inclusions-dto';
import { WorkSetCalculationitemsDeliveredDto } from '../models/work-set-calculationitems-delivered-dto';
import { WorkSplitCalculationitemDto } from '../models/work-split-calculationitem-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkToOrderItemSummaryDto } from '../models/work-to-order-item-summary-dto';
import { WorkToOrderProjectLineDto } from '../models/work-to-order-project-line-dto';
import { WorkToggleOptionalForSaleDto } from '../models/work-toggle-optional-for-sale-dto';
import { WorkUpdateCalculationitemDto } from '../models/work-update-calculationitem-dto';
import { WorkUpdateCalculationitemPropertyDto } from '../models/work-update-calculationitem-property-dto';
import { WorkUpdateCalculationitemSortableRankDto } from '../models/work-update-calculationitem-sortable-rank-dto';

@Injectable({ providedIn: 'root' })
export class WorkCalculationitemsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `calculationitemsV2ControllerFindItemSummariesToOrder()` */
  static readonly CalculationitemsV2ControllerFindItemSummariesToOrderPath = '/v2/calculationitems/to-order';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindItemSummariesToOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindItemSummariesToOrder$Response(
    params?: {
      containertypeIds?: Array<number>;
      projectContainertypeIds?: Array<number>;
      productgroupIds?: Array<number>;
      vendorIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkToOrderItemSummaryDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindItemSummariesToOrderPath, 'get');
    if (params) {
      rb.query('containertypeIds', params.containertypeIds, {});
      rb.query('projectContainertypeIds', params.projectContainertypeIds, {});
      rb.query('productgroupIds', params.productgroupIds, {});
      rb.query('vendorIds', params.vendorIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkToOrderItemSummaryDto>>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindItemSummariesToOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindItemSummariesToOrder(
    params?: {
      containertypeIds?: Array<number>;
      projectContainertypeIds?: Array<number>;
      productgroupIds?: Array<number>;
      vendorIds?: Array<number>;
    },
    context?: HttpContext
  ): Observable<Array<WorkToOrderItemSummaryDto>> {
    return this.calculationitemsV2ControllerFindItemSummariesToOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkToOrderItemSummaryDto>>): Array<WorkToOrderItemSummaryDto> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindProjectLinesToOrder()` */
  static readonly CalculationitemsV2ControllerFindProjectLinesToOrderPath = '/v2/calculationitems/to-order/{itemId}/projects';

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindProjectLinesToOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindProjectLinesToOrder$Response(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkToOrderProjectLineDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindProjectLinesToOrderPath, 'get');
    if (params) {
      rb.path('itemId', params.itemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkToOrderProjectLineDto>>;
      })
    );
  }

  /**
   * Required permissions: orders:read, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindProjectLinesToOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindProjectLinesToOrder(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkToOrderProjectLineDto>> {
    return this.calculationitemsV2ControllerFindProjectLinesToOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkToOrderProjectLineDto>>): Array<WorkToOrderProjectLineDto> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginated()` */
  static readonly CalculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginatedPath = '/v2/calculationitems/byCalculationId/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by calculationId query param.
     *           <p>
     *              <b>Format: </b> filter.calculationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationId=$not:$like:John Doe&filter.calculationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.calculationId'?: Array<string>;

    /**
     * Filter by optional query param.
     *           <p>
     *              <b>Format: </b> filter.optional={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.optional=$not:$like:John Doe&filter.optional=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.optional'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> item.name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>item.name</li>
     * <li>targetAmount</li>
     * <li>purchaseChf</li>
     * <li>budgetPrice</li>
     * <li>notes</li>
     * <li>stocklocation.name</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'item.name:ASC' | 'item.name:DESC' | 'targetAmount:ASC' | 'targetAmount:DESC' | 'purchaseChf:ASC' | 'purchaseChf:DESC' | 'budgetPrice:ASC' | 'budgetPrice:DESC' | 'notes:ASC' | 'notes:DESC' | 'stocklocation.name:ASC' | 'stocklocation.name:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'optional'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.calculationId', params['filter.calculationId'], {});
      rb.query('filter.optional', params['filter.optional'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkCalculationitem>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'calculationId'?: (string | Array<string>);
        'optional'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by calculationId query param.
     *           <p>
     *              <b>Format: </b> filter.calculationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationId=$not:$like:John Doe&filter.calculationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.calculationId'?: Array<string>;

    /**
     * Filter by optional query param.
     *           <p>
     *              <b>Format: </b> filter.optional={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.optional=$not:$like:John Doe&filter.optional=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li></ul>
     */
      'filter.optional'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> item.name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>item.name</li>
     * <li>targetAmount</li>
     * <li>purchaseChf</li>
     * <li>budgetPrice</li>
     * <li>notes</li>
     * <li>stocklocation.name</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'item.name:ASC' | 'item.name:DESC' | 'targetAmount:ASC' | 'targetAmount:DESC' | 'purchaseChf:ASC' | 'purchaseChf:DESC' | 'budgetPrice:ASC' | 'budgetPrice:DESC' | 'notes:ASC' | 'notes:DESC' | 'stocklocation.name:ASC' | 'stocklocation.name:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'optional'?: (string | Array<string>);
};
};
}> {
    return this.calculationitemsV2ControllerFindAllCalculationitemsByCalculationIdPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'optional'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'calculationId'?: (string | Array<string>);
'optional'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginated()` */
  static readonly CalculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginatedPath = '/v2/calculationitems/byItemId/{id}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginated$Response(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by orderId query param.
     *           <p>
     *              <b>Format: </b> filter.orderId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderId=$not:$like:John Doe&filter.orderId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li>
     * <li>$not</li></ul>
     */
      'filter.orderId'?: Array<string>;

    /**
     * Filter by orderAt query param.
     *           <p>
     *              <b>Format: </b> filter.orderAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderAt=$not:$like:John Doe&filter.orderAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.orderAt'?: Array<string>;

    /**
     * Filter by deliveredAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliveredAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliveredAt=$not:$like:John Doe&filter.deliveredAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliveredAt'?: Array<string>;

    /**
     * Filter by stocklocationId query param.
     *           <p>
     *              <b>Format: </b> filter.stocklocationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.stocklocationId=$not:$like:John Doe&filter.stocklocationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.stocklocationId'?: Array<string>;

    /**
     * Filter by calculationId query param.
     *           <p>
     *              <b>Format: </b> filter.calculationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationId=$not:$like:John Doe&filter.calculationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.calculationId'?: Array<string>;

    /**
     * Filter by calculation.project.sale query param.
     *           <p>
     *              <b>Format: </b> filter.calculation.project.sale={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculation.project.sale=$not:$like:John Doe&filter.calculation.project.sale=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.calculation.project.sale'?: Array<string>;

    /**
     * Filter by calculation.project.isLagerProject query param.
     *           <p>
     *              <b>Format: </b> filter.calculation.project.isLagerProject={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculation.project.isLagerProject=$not:$like:John Doe&filter.calculation.project.isLagerProject=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.calculation.project.isLagerProject'?: Array<string>;

    /**
     * Filter by missingAtImplementation query param.
     *           <p>
     *              <b>Format: </b> filter.missingAtImplementation={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.missingAtImplementation=$not:$like:John Doe&filter.missingAtImplementation=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.missingAtImplementation'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> calculation.project.installationStart:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>targetAmount</li>
     * <li>deliverAt</li>
     * <li>stocklocationId</li>
     * <li>order.name</li>
     * <li>calculation.project.build</li>
     * <li>calculation.project.numberQualified</li>
     * <li>calculation.project.installationStart</li>
     * <li>calculation.project.installationEnd</li></ul>
     */
      sortBy?: Array<'targetAmount:ASC' | 'targetAmount:DESC' | 'deliverAt:ASC' | 'deliverAt:DESC' | 'stocklocationId:ASC' | 'stocklocationId:DESC' | 'order.name:ASC' | 'order.name:DESC' | 'calculation.project.build:ASC' | 'calculation.project.build:DESC' | 'calculation.project.numberQualified:ASC' | 'calculation.project.numberQualified:DESC' | 'calculation.project.installationStart:ASC' | 'calculation.project.installationStart:DESC' | 'calculation.project.installationEnd:ASC' | 'calculation.project.installationEnd:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderId'?: (string | Array<string>);
'orderAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
'calculationId'?: (string | Array<string>);
'calculation.project.sale'?: (string | Array<string>);
'calculation.project.isLagerProject'?: (string | Array<string>);
'missingAtImplementation'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginatedPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.orderId', params['filter.orderId'], {});
      rb.query('filter.orderAt', params['filter.orderAt'], {});
      rb.query('filter.deliveredAt', params['filter.deliveredAt'], {});
      rb.query('filter.stocklocationId', params['filter.stocklocationId'], {});
      rb.query('filter.calculationId', params['filter.calculationId'], {});
      rb.query('filter.calculation.project.sale', params['filter.calculation.project.sale'], {});
      rb.query('filter.calculation.project.isLagerProject', params['filter.calculation.project.isLagerProject'], {});
      rb.query('filter.missingAtImplementation', params['filter.missingAtImplementation'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkCalculationitem>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'orderId'?: (string | Array<string>);
        'orderAt'?: (string | Array<string>);
        'deliveredAt'?: (string | Array<string>);
        'stocklocationId'?: (string | Array<string>);
        'calculationId'?: (string | Array<string>);
        'calculation.project.sale'?: (string | Array<string>);
        'calculation.project.isLagerProject'?: (string | Array<string>);
        'missingAtImplementation'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginated(
    params: {
      id: number;

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 1000
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by orderId query param.
     *           <p>
     *              <b>Format: </b> filter.orderId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderId=$not:$like:John Doe&filter.orderId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$in</li>
     * <li>$not</li></ul>
     */
      'filter.orderId'?: Array<string>;

    /**
     * Filter by orderAt query param.
     *           <p>
     *              <b>Format: </b> filter.orderAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.orderAt=$not:$like:John Doe&filter.orderAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.orderAt'?: Array<string>;

    /**
     * Filter by deliveredAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliveredAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliveredAt=$not:$like:John Doe&filter.deliveredAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliveredAt'?: Array<string>;

    /**
     * Filter by stocklocationId query param.
     *           <p>
     *              <b>Format: </b> filter.stocklocationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.stocklocationId=$not:$like:John Doe&filter.stocklocationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.stocklocationId'?: Array<string>;

    /**
     * Filter by calculationId query param.
     *           <p>
     *              <b>Format: </b> filter.calculationId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculationId=$not:$like:John Doe&filter.calculationId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.calculationId'?: Array<string>;

    /**
     * Filter by calculation.project.sale query param.
     *           <p>
     *              <b>Format: </b> filter.calculation.project.sale={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculation.project.sale=$not:$like:John Doe&filter.calculation.project.sale=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.calculation.project.sale'?: Array<string>;

    /**
     * Filter by calculation.project.isLagerProject query param.
     *           <p>
     *              <b>Format: </b> filter.calculation.project.isLagerProject={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.calculation.project.isLagerProject=$not:$like:John Doe&filter.calculation.project.isLagerProject=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.calculation.project.isLagerProject'?: Array<string>;

    /**
     * Filter by missingAtImplementation query param.
     *           <p>
     *              <b>Format: </b> filter.missingAtImplementation={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.missingAtImplementation=$not:$like:John Doe&filter.missingAtImplementation=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.missingAtImplementation'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> calculation.project.installationStart:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>targetAmount</li>
     * <li>deliverAt</li>
     * <li>stocklocationId</li>
     * <li>order.name</li>
     * <li>calculation.project.build</li>
     * <li>calculation.project.numberQualified</li>
     * <li>calculation.project.installationStart</li>
     * <li>calculation.project.installationEnd</li></ul>
     */
      sortBy?: Array<'targetAmount:ASC' | 'targetAmount:DESC' | 'deliverAt:ASC' | 'deliverAt:DESC' | 'stocklocationId:ASC' | 'stocklocationId:DESC' | 'order.name:ASC' | 'order.name:DESC' | 'calculation.project.build:ASC' | 'calculation.project.build:DESC' | 'calculation.project.numberQualified:ASC' | 'calculation.project.numberQualified:DESC' | 'calculation.project.installationStart:ASC' | 'calculation.project.installationStart:DESC' | 'calculation.project.installationEnd:ASC' | 'calculation.project.installationEnd:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderId'?: (string | Array<string>);
'orderAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
'calculationId'?: (string | Array<string>);
'calculation.project.sale'?: (string | Array<string>);
'calculation.project.isLagerProject'?: (string | Array<string>);
'missingAtImplementation'?: (string | Array<string>);
};
};
}> {
    return this.calculationitemsV2ControllerFindAllCalculationitemsByItemIdPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderId'?: (string | Array<string>);
'orderAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
'calculationId'?: (string | Array<string>);
'calculation.project.sale'?: (string | Array<string>);
'calculation.project.isLagerProject'?: (string | Array<string>);
'missingAtImplementation'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'orderId'?: (string | Array<string>);
'orderAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
'stocklocationId'?: (string | Array<string>);
'calculationId'?: (string | Array<string>);
'calculation.project.sale'?: (string | Array<string>);
'calculation.project.isLagerProject'?: (string | Array<string>);
'missingAtImplementation'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindAllDeliveriesPaginated()` */
  static readonly CalculationitemsV2ControllerFindAllDeliveriesPaginatedPath = '/v2/calculationitems/deliveries';

  /**
   * Required permissions: orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindAllDeliveriesPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllDeliveriesPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 200
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by item.productgroupId query param.
     *           <p>
     *              <b>Format: </b> filter.item.productgroupId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.item.productgroupId=$not:$like:John Doe&filter.item.productgroupId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.item.productgroupId'?: Array<string>;

    /**
     * Filter by item.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.item.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.item.containertypeId=$not:$like:John Doe&filter.item.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.item.containertypeId'?: Array<string>;

    /**
     * Filter by deliverAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliverAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliverAt=$not:$like:John Doe&filter.deliverAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gt</li>
     * <li>$gte</li>
     * <li>$lt</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliverAt'?: Array<string>;

    /**
     * Filter by deliveredAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliveredAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliveredAt=$not:$like:John Doe&filter.deliveredAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliveredAt'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> deliverAt:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>item.name</li>
     * <li>order.name</li>
     * <li>targetAmount</li>
     * <li>orderAt</li>
     * <li>deliverAt</li>
     * <li>orderByContact.company</li></ul>
     */
      sortBy?: Array<'item.name:ASC' | 'item.name:DESC' | 'order.name:ASC' | 'order.name:DESC' | 'targetAmount:ASC' | 'targetAmount:DESC' | 'orderAt:ASC' | 'orderAt:DESC' | 'deliverAt:ASC' | 'deliverAt:DESC' | 'orderByContact.company:ASC' | 'orderByContact.company:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> item.name,order.name,orderByContact.company,orderByContact.firstName,orderByContact.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>item.name</li>
     * <li>order.name</li>
     * <li>orderByContact.company</li>
     * <li>orderByContact.firstName</li>
     * <li>orderByContact.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'item.productgroupId'?: (string | Array<string>);
'item.containertypeId'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindAllDeliveriesPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.item.productgroupId', params['filter.item.productgroupId'], {});
      rb.query('filter.item.containertypeId', params['filter.item.containertypeId'], {});
      rb.query('filter.deliverAt', params['filter.deliverAt'], {});
      rb.query('filter.deliveredAt', params['filter.deliveredAt'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkCalculationitem>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'item.productgroupId'?: (string | Array<string>);
        'item.containertypeId'?: (string | Array<string>);
        'deliverAt'?: (string | Array<string>);
        'deliveredAt'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindAllDeliveriesPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllDeliveriesPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 50
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 200
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by item.productgroupId query param.
     *           <p>
     *              <b>Format: </b> filter.item.productgroupId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.item.productgroupId=$not:$like:John Doe&filter.item.productgroupId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.item.productgroupId'?: Array<string>;

    /**
     * Filter by item.containertypeId query param.
     *           <p>
     *              <b>Format: </b> filter.item.containertypeId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.item.containertypeId=$not:$like:John Doe&filter.item.containertypeId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li>
     * <li>$in</li></ul>
     */
      'filter.item.containertypeId'?: Array<string>;

    /**
     * Filter by deliverAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliverAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliverAt=$not:$like:John Doe&filter.deliverAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gt</li>
     * <li>$gte</li>
     * <li>$lt</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliverAt'?: Array<string>;

    /**
     * Filter by deliveredAt query param.
     *           <p>
     *              <b>Format: </b> filter.deliveredAt={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.deliveredAt=$not:$like:John Doe&filter.deliveredAt=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$gte</li>
     * <li>$lte</li>
     * <li>$btw</li>
     * <li>$null</li>
     * <li>$not</li></ul>
     */
      'filter.deliveredAt'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> deliverAt:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>item.name</li>
     * <li>order.name</li>
     * <li>targetAmount</li>
     * <li>orderAt</li>
     * <li>deliverAt</li>
     * <li>orderByContact.company</li></ul>
     */
      sortBy?: Array<'item.name:ASC' | 'item.name:DESC' | 'order.name:ASC' | 'order.name:DESC' | 'targetAmount:ASC' | 'targetAmount:DESC' | 'orderAt:ASC' | 'orderAt:DESC' | 'deliverAt:ASC' | 'deliverAt:DESC' | 'orderByContact.company:ASC' | 'orderByContact.company:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> item.name,order.name,orderByContact.company,orderByContact.firstName,orderByContact.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>item.name</li>
     * <li>order.name</li>
     * <li>orderByContact.company</li>
     * <li>orderByContact.firstName</li>
     * <li>orderByContact.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'item.productgroupId'?: (string | Array<string>);
'item.containertypeId'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
};
};
}> {
    return this.calculationitemsV2ControllerFindAllDeliveriesPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'item.productgroupId'?: (string | Array<string>);
'item.containertypeId'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkCalculationitem>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'item.productgroupId'?: (string | Array<string>);
'item.containertypeId'?: (string | Array<string>);
'deliverAt'?: (string | Array<string>);
'deliveredAt'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerSetDelivered()` */
  static readonly CalculationitemsV2ControllerSetDeliveredPath = '/v2/calculationitems/set-delivered';

  /**
   * Required permissions: orders:admin, orders:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerSetDelivered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerSetDelivered$Response(
    params: {
      body: WorkSetCalculationitemsDeliveredDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerSetDeliveredPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: orders:admin, orders:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerSetDelivered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerSetDelivered(
    params: {
      body: WorkSetCalculationitemsDeliveredDto
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.calculationitemsV2ControllerSetDelivered$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerRemoveFromOrder()` */
  static readonly CalculationitemsV2ControllerRemoveFromOrderPath = '/v2/calculationitems/{id}/remove-from-order';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerRemoveFromOrder()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerRemoveFromOrder$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerRemoveFromOrderPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerRemoveFromOrder$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerRemoveFromOrder(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerRemoveFromOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerSplit()` */
  static readonly CalculationitemsV2ControllerSplitPath = '/v2/calculationitems/{id}/split';

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerSplit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerSplit$Response(
    params: {
      id: number;
      body: WorkSplitCalculationitemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerSplitPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: orders:update, orders:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerSplit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerSplit(
    params: {
      id: number;
      body: WorkSplitCalculationitemDto
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.calculationitemsV2ControllerSplit$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindAllCalculationitemsByContactId()` */
  static readonly CalculationitemsV2ControllerFindAllCalculationitemsByContactIdPath = '/v2/calculationitems/byContactId/{contactId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindAllCalculationitemsByContactId()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllCalculationitemsByContactId$Response(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindAllCalculationitemsByContactIdPath, 'get');
    if (params) {
      rb.path('contactId', params.contactId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindAllCalculationitemsByContactId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllCalculationitemsByContactId(
    params: {
      contactId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.calculationitemsV2ControllerFindAllCalculationitemsByContactId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindAllOptionalCalculationItemsForProject()` */
  static readonly CalculationitemsV2ControllerFindAllOptionalCalculationItemsForProjectPath = '/v2/calculationitems/allOptionalsByProjectId/{projectId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindAllOptionalCalculationItemsForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllOptionalCalculationItemsForProject$Response(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindAllOptionalCalculationItemsForProjectPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindAllOptionalCalculationItemsForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindAllOptionalCalculationItemsForProject(
    params: {
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.calculationitemsV2ControllerFindAllOptionalCalculationItemsForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindOrdersForDepotOverviewFilter()` */
  static readonly CalculationitemsV2ControllerFindOrdersForDepotOverviewFilterPath = '/v2/calculationitems/ordersForDepotOverviewFilter/{itemId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindOrdersForDepotOverviewFilter()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindOrdersForDepotOverviewFilter$Response(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindOrdersForDepotOverviewFilterPath, 'get');
    if (params) {
      rb.path('itemId', params.itemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindOrdersForDepotOverviewFilter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindOrdersForDepotOverviewFilter(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.calculationitemsV2ControllerFindOrdersForDepotOverviewFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerUpdateSortableRankForCalculationitems()` */
  static readonly CalculationitemsV2ControllerUpdateSortableRankForCalculationitemsPath = '/v2/calculationitems/sortableRanks';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerUpdateSortableRankForCalculationitems()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerUpdateSortableRankForCalculationitems$Response(
    params: {
      body: Array<WorkUpdateCalculationitemSortableRankDto>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerUpdateSortableRankForCalculationitemsPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerUpdateSortableRankForCalculationitems$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerUpdateSortableRankForCalculationitems(
    params: {
      body: Array<WorkUpdateCalculationitemSortableRankDto>
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.calculationitemsV2ControllerUpdateSortableRankForCalculationitems$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerUpdateSingleProperty()` */
  static readonly CalculationitemsV2ControllerUpdateSinglePropertyPath = '/v2/calculationitems/singleProperty';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerUpdateSingleProperty()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerUpdateSingleProperty$Response(
    params: {
      body: WorkUpdateCalculationitemPropertyDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerUpdateSinglePropertyPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerUpdateSingleProperty$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerUpdateSingleProperty(
    params: {
      body: WorkUpdateCalculationitemPropertyDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerUpdateSingleProperty$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerMoveItemAmountsToNewProject()` */
  static readonly CalculationitemsV2ControllerMoveItemAmountsToNewProjectPath = '/v2/calculationitems/moveItemAmountsToNewProject';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerMoveItemAmountsToNewProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerMoveItemAmountsToNewProject$Response(
    params: {
      body: Array<string>
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerMoveItemAmountsToNewProjectPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerMoveItemAmountsToNewProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerMoveItemAmountsToNewProject(
    params: {
      body: Array<string>
    },
    context?: HttpContext
  ): Observable<void> {
    return this.calculationitemsV2ControllerMoveItemAmountsToNewProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerCalculateItemTotals()` */
  static readonly CalculationitemsV2ControllerCalculateItemTotalsPath = '/v2/calculationitems/calculateItemTotals/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerCalculateItemTotals()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerCalculateItemTotals$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerCalculateItemTotalsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerCalculateItemTotals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerCalculateItemTotals(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerCalculateItemTotals$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerRecalculateDerivedTotalsForCalculation()` */
  static readonly CalculationitemsV2ControllerRecalculateDerivedTotalsForCalculationPath = '/v2/calculationitems/recalculateDerivedTotalsForCalculation/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerRecalculateDerivedTotalsForCalculation()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerRecalculateDerivedTotalsForCalculation$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerRecalculateDerivedTotalsForCalculationPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerRecalculateDerivedTotalsForCalculation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerRecalculateDerivedTotalsForCalculation(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.calculationitemsV2ControllerRecalculateDerivedTotalsForCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerCalculateAllItemTotalsForCalculation()` */
  static readonly CalculationitemsV2ControllerCalculateAllItemTotalsForCalculationPath = '/v2/calculationitems/calculateAllItemTotalsForCalculation/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerCalculateAllItemTotalsForCalculation()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerCalculateAllItemTotalsForCalculation$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerCalculateAllItemTotalsForCalculationPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerCalculateAllItemTotalsForCalculation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerCalculateAllItemTotalsForCalculation(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.calculationitemsV2ControllerCalculateAllItemTotalsForCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerImportLatestPricesForCalculation()` */
  static readonly CalculationitemsV2ControllerImportLatestPricesForCalculationPath = '/v2/calculationitems/importLatestPricesForCalculation/{calculationId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerImportLatestPricesForCalculation()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerImportLatestPricesForCalculation$Response(
    params: {
      calculationId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerImportLatestPricesForCalculationPath, 'patch');
    if (params) {
      rb.path('calculationId', params.calculationId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerImportLatestPricesForCalculation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerImportLatestPricesForCalculation(
    params: {
      calculationId: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.calculationitemsV2ControllerImportLatestPricesForCalculation$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerImportLatestPricesForItem()` */
  static readonly CalculationitemsV2ControllerImportLatestPricesForItemPath = '/v2/calculationitems/importLatestPricesForItem/{itemId}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerImportLatestPricesForItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerImportLatestPricesForItem$Response(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerImportLatestPricesForItemPath, 'patch');
    if (params) {
      rb.path('itemId', params.itemId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerImportLatestPricesForItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerImportLatestPricesForItem(
    params: {
      itemId: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.calculationitemsV2ControllerImportLatestPricesForItem$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerDelete()` */
  static readonly CalculationitemsV2ControllerDeletePath = '/v2/calculationitems/{id}';

  /**
   * Required permissions: projects:delete, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: projects:delete, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.calculationitemsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerUpdate()` */
  static readonly CalculationitemsV2ControllerUpdatePath = '/v2/calculationitems/{id}';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerUpdate$Response(
    params: {
      id: number;
      skipGroupTotals: boolean;
      skipCalculationTotals: boolean;
      body: WorkUpdateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('skipGroupTotals', params.skipGroupTotals, {});
      rb.query('skipCalculationTotals', params.skipCalculationTotals, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerUpdate(
    params: {
      id: number;
      skipGroupTotals: boolean;
      skipCalculationTotals: boolean;
      body: WorkUpdateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerCreate()` */
  static readonly CalculationitemsV2ControllerCreatePath = '/v2/calculationitems';

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerCreate$Response(
    params: {
      body: WorkCreateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerCreate(
    params: {
      body: WorkCreateCalculationitemDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerMoveToProjects()` */
  static readonly CalculationitemsV2ControllerMoveToProjectsPath = '/v2/calculationitems/move-to-projects';

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerMoveToProjects()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerMoveToProjects$Response(
    params: {
      body: WorkMoveCalculationItemsToProjectsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerMoveToProjectsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerMoveToProjects$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerMoveToProjects(
    params: {
      body: WorkMoveCalculationItemsToProjectsDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.calculationitemsV2ControllerMoveToProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerToggleOptionalForSale()` */
  static readonly CalculationitemsV2ControllerToggleOptionalForSalePath = '/v2/calculationitems/toggle-optional-for-sale';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerToggleOptionalForSale()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerToggleOptionalForSale$Response(
    params: {
      body: WorkToggleOptionalForSaleDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerToggleOptionalForSalePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerToggleOptionalForSale$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerToggleOptionalForSale(
    params: {
      body: WorkToggleOptionalForSaleDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerToggleOptionalForSale$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerExplodeIntoBillOfMaterials()` */
  static readonly CalculationitemsV2ControllerExplodeIntoBillOfMaterialsPath = '/v2/calculationitems/{id}/explode';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerExplodeIntoBillOfMaterials()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerExplodeIntoBillOfMaterials$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerExplodeIntoBillOfMaterialsPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerExplodeIntoBillOfMaterials$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerExplodeIntoBillOfMaterials(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.calculationitemsV2ControllerExplodeIntoBillOfMaterials$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerAddCalculationItemForSale()` */
  static readonly CalculationitemsV2ControllerAddCalculationItemForSalePath = '/v2/calculationitems/add-for-sale';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerAddCalculationItemForSale()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerAddCalculationItemForSale$Response(
    params: {
      body: WorkAddCalculationitemForSaleDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerAddCalculationItemForSalePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerAddCalculationItemForSale$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerAddCalculationItemForSale(
    params: {
      body: WorkAddCalculationitemForSaleDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerAddCalculationItemForSale$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerCreateDiscountCalculationitem()` */
  static readonly CalculationitemsV2ControllerCreateDiscountCalculationitemPath = '/v2/calculationitems/discount';

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerCreateDiscountCalculationitem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerCreateDiscountCalculationitem$Response(
    params: {
      body: WorkCreateDiscountCalculationitemDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculationitem>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerCreateDiscountCalculationitemPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculationitem>;
      })
    );
  }

  /**
   * Required permissions: projects:create, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerCreateDiscountCalculationitem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerCreateDiscountCalculationitem(
    params: {
      body: WorkCreateDiscountCalculationitemDto
    },
    context?: HttpContext
  ): Observable<WorkCalculationitem> {
    return this.calculationitemsV2ControllerCreateDiscountCalculationitem$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculationitem>): WorkCalculationitem => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerFindDiscountItemsByCalculationId()` */
  static readonly CalculationitemsV2ControllerFindDiscountItemsByCalculationIdPath = '/v2/calculationitems/discount/{calculationId}';

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerFindDiscountItemsByCalculationId()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindDiscountItemsByCalculationId$Response(
    params: {
      calculationId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerFindDiscountItemsByCalculationIdPath, 'get');
    if (params) {
      rb.path('calculationId', params.calculationId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: projects:read, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerFindDiscountItemsByCalculationId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  calculationitemsV2ControllerFindDiscountItemsByCalculationId(
    params: {
      calculationId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.calculationitemsV2ControllerFindDiscountItemsByCalculationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `calculationitemsV2ControllerRevertPendingOptionalInclusions()` */
  static readonly CalculationitemsV2ControllerRevertPendingOptionalInclusionsPath = '/v2/calculationitems/revert-pending-optional-inclusions';

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `calculationitemsV2ControllerRevertPendingOptionalInclusions()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerRevertPendingOptionalInclusions$Response(
    params: {
      body: WorkRevertPendingOptionalInclusionsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCalculation>> {
    const rb = new RequestBuilder(this.rootUrl, WorkCalculationitemsV2Service.CalculationitemsV2ControllerRevertPendingOptionalInclusionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCalculation>;
      })
    );
  }

  /**
   * Required permissions: projects:update, projects:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `calculationitemsV2ControllerRevertPendingOptionalInclusions$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  calculationitemsV2ControllerRevertPendingOptionalInclusions(
    params: {
      body: WorkRevertPendingOptionalInclusionsDto
    },
    context?: HttpContext
  ): Observable<WorkCalculation> {
    return this.calculationitemsV2ControllerRevertPendingOptionalInclusions$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCalculation>): WorkCalculation => r.body)
    );
  }

}
